export const environment = {
    production: true,
    url: 'https://stg-regulation-api.b2tech.com',
    version: '1.0.137',
};
